import { send_z3k_custom_command } from 'console/redux/z3k-custom-command/actions';
import { selectDevice } from 'entities/device/lib';
export const CLIMATIC_SET_MODE_FOR_CIRCUIT = 'CLIMATIC_SET_MODE_FOR_CIRCUIT';
export const climatic_set_mode_for_circuit = (device_id, circuit_id, mode_id) => (dispatch, _getState) => {
    dispatch(send_z3k_custom_command(device_id, {
        command_name: 'SelectHeatingModeForCircuit',
        object_id: circuit_id,
        command_args: { mode_id },
    }));
    dispatch({ type: CLIMATIC_SET_MODE_FOR_CIRCUIT, device_id, circuit_id });
};
export const climatic_run_mode_scenario = (device_id, scenario_object_id) => (dispatch, getState) => {
    dispatch(send_z3k_custom_command(device_id, {
        command_name: 'RunScenario',
        object_id: scenario_object_id,
        command_args: null,
    }));
    selectDevice(getState(), device_id)?.z3k_config?.heating_circuits?.forEach((hc) => dispatch({
        type: CLIMATIC_SET_MODE_FOR_CIRCUIT,
        device_id,
        circuit_id: hc.id,
    }));
};
